import { useRef } from "react";

let idCounter = 0;

export function useStableId(prefix?: string): string {
  const ref = useRef<string | null>(null);
  if (ref.current === null) {
    idCounter += 1;
    ref.current = (prefix || "field") + "-" + idCounter;
  }
  return ref.current;
}
